import api from './images/api.png';
import cpp from './images/cpp.png';
import graphql from './images/graphql.png';
import html from './images/html.png';
import javascript from './images/javascript.png';
import node from './images/node.png';
import python from './images/python.png';
import redux from './images/redux.png';
import sass from './images/sass.png';
import typescript from './images/typescript.png';
import circle from './images/circle.svg';
import shasa1 from './images/shasa1.png';
import logo from "./images/logo.png";
import react from "./images/reactTransparent.png";

const images = {
    shasa1,
    api,
    cpp,
    graphql,
    html,
    javascript,
    node,
    python,
    redux,
    sass,
    typescript,
    circle,
    logo,
    react
};

export default images;